import { selectAccessibilityPrefs } from '../../../../../../../../db/app/selectors';
import { useAppSelector } from '../../../../../../../../store/hooks';

const useCommentActions = () => {
  const { turnOff } = useAppSelector((state) => selectAccessibilityPrefs(state));
  const isScreenReaderOn = !turnOff;

  return { isScreenReaderOn };
};

export default useCommentActions;
